var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 6.25H11.6667V10H18.3334V6.25Z",
    fill: "#21A366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10H5V16.6667C5 17.1271 5.37292 17.5 5.83333 17.5H17.5C17.9604 17.5 18.3333 17.1271 18.3333 16.6667V10Z",
    fill: "#185C37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10H11.6667V13.75H18.3334V10Z",
    fill: "#107C42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.25H5V10H11.6667V6.25Z",
    fill: "#3FA071"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 2.5H11.6667V6.25H18.3334V3.33333C18.3334 2.87292 17.9605 2.5 17.5001 2.5Z",
    fill: "#33C481"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 2.5H11.6667V6.25H5V3.33333C5 2.87292 5.37292 2.5 5.83333 2.5Z",
    fill: "#21A366"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M9.29958 5.41666H5V15.4167H9.29958C10.1467 15.4167 10.8333 14.73 10.8333 13.8829V6.95041C10.8333 6.10333 10.1467 5.41666 9.29958 5.41666Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M9.25542 15H5V5.55542H9.25542C9.97375 5.55542 10.5558 6.1375 10.5558 6.85584V13.6996C10.5554 14.4179 9.97333 15 9.25542 15Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M9.21083 14.5833H5V5.69458H9.21083C9.8 5.69458 10.2775 6.17208 10.2775 6.76125V13.5167C10.2779 14.1058 9.8 14.5833 9.21083 14.5833Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 14.1667H2.50008C2.03966 14.1667 1.66675 13.7938 1.66675 13.3333V6.66667C1.66675 6.20625 2.03966 5.83334 2.50008 5.83334H9.16675C9.62716 5.83334 10.0001 6.20625 10.0001 6.66667V13.3333C10.0001 13.7938 9.62716 14.1667 9.16675 14.1667Z",
    fill: "url(#paint0_linear_5760_5181)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08632 7.91666H5.08049L5.88715 9.48083L6.73965 7.91666H7.6684L6.38882 10L7.69757 12.0833H6.71799L5.83882 10.4458L4.9634 12.0833H3.96924L5.29965 9.9925L4.08632 7.91666Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5760_5181",
    x1: 1.96883,
    y1: 6.13542,
    x2: 9.60633,
    y2: 13.7729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6731"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.92b7d5a41b3d7a0007c590b2bdee9ddb.svg";
export { ForwardRef as ReactComponent };